module.exports = __webpack_public_path__ + "Tinebase/js/ace-mode-scss-FAT.js";